import {Component, OnInit, ViewChild, ViewEncapsulation,Output,EventEmitter,Input} from '@angular/core';
import {CompanyModel} from "../../../shared/models/company.model";
import {PageMeta} from "../../../shared/models/page.model";
import {PortfolioModel, VISIBILITY_PRIVATE} from "../../../shared/models/portfolio.model";
import {MatStepper} from "@angular/material/stepper";
import {UploadDialogComponent} from "../../../components/upload-dialog/upload-dialog.component";
import moment from "moment";
import { BasePortfolioCreateComponent } from '../base-portfolio-create/base-portfolio-create.component';
import {
  NewPortfolioSelectDialogComponent
} from "./components/new-portfolio-select-dialog/new-portfolio-select-dialog.component";

@Component({
  selector: 'app-portfolio-create',
  templateUrl: './portfolio-create.component.html',
  styleUrls: ['./portfolio-create.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: []
})
export class PortfolioCreateComponent extends BasePortfolioCreateComponent implements OnInit {
  @ViewChild('stepper') private myStepper: MatStepper;
  @Input() startDateChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() startingDate: EventEmitter<any> = new EventEmitter<any>();

  selectLimit = 100;

  selectedPortfolioType = null;

  portfolio = new PortfolioModel({
    description: "",
    currency_id: 42,
    weighting_type: 'equal',
    rebalancing_type: 'no'
  })
  currentPage = 1;
  searchTerm = ''
  selectedStep = 0;
  meta: PageMeta = {};
  list: CompanyModel[] = [];
  selected: CompanyModel[] = [];

  // Select input lists
  filterLists: any = {
    markets: [],
    regions: [],
    countries: [],
    sectors: [],
    industries: [],
    currencies: [],
    main_currencies: [],
    size_classification: [],
    exchange_code_fs: [],
    country_of_risk: [],
    expectedResults: null,
    flags: [],
    DomicileName: [],
    BrandingCompanyName: [],
    LocalCategoryName: [],
    GlobalCategoryName: [],
    EquityStyleBox:[],
    FeeLevel:[],
    MorningStarRating:[],
    FundOfFunds: [],
    UCITS: [],
    BaseCurrency: []
  }

  max_start_date = null;
  weightError = false;
  weightSumError = false;
  hasETF = false;

  priorityCurrencies = ['USD', 'EUR', 'GBP', 'SEK', 'NOK', 'DKK'];
  selectedCurrencies: any[] = [];

  portfolioLoadedInService: PortfolioModel = null;

  selectedSorting = 'company_name';

  // Static filter list constants
  private static readonly SIZE_CLASSIFICATIONS = [
    { id: "Micro Cap", name: "Micro Cap" },
    { id: "Small Cap", name: "Small Cap" },
    { id: "Mid Cap", name: "Mid Cap" },
    { id: "Large Cap", name: "Large Cap" },
    { id: "Mega Cap", name: "Mega Cap" }
  ];

  private static readonly FLAGS = [
    { id: "0", name: "0" },
    { id: "1", name: "1" }
  ];

  private static readonly COUNTRY_CODES = [
    "AE", "AR", "AT", "AU", "BB", "BE", "BF", "BG", "BH", "BM", "BR", "BS", "BW", "CA", "CD", "CG", "CH", "CL", "CN", 
    "CO", "CR", "CY", "CZ", "DE", "DK", "EC", "EE", "EG", "ES", "FI", "FO", "FR", "GA", "GB", "GE", "GH", "GR", "HK", 
    "HR", "HU", "ID", "IE", "IL", "IN", "IQ", "IS", "IT", "JE", "JO", "JP", "KE", "KH", "KR", "KW", "KY", "KZ", "LA", 
    "LB", "LI", "LK", "LT", "LU", "LV", "MA", "MC", "ML", "MM", "MO", "MT", "MU", "MX", "MY", "MZ", "NG", "NI", "NL", 
    "NO", "NZ", "OM", "PA", "PE", "PG", "PH", "PL", "PR", "PS", "PT", "QA", "RO", "RU", "SA", "SE", "SG", "SI", "SK", 
    "TH", "TJ", "TR", "TT", "TW", "UA", "US", "UY", "VG", "VN", "ZA", "ZW"
  ].map(code => ({ id: code, name: code }));

  ngOnInit() {
    this.service.portfolio$.subscribe(res => this.portfolioLoadedInService = res);
    this.fetchCompaniesIn();
    this.initPage();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy?.();
  }

  initPage() {
    if (this.service.uploadedCompanies.length > 0) {
      this.recalculateWeight()
    }

  }

  getFiltersIn(filter?) {
    let extraFilters: any = {}
    if (filter && filter.limit) {
      extraFilters.limit = filter.limit;
      delete filter.limit;
    }
    this.service.fetchData(filter, extraFilters).subscribe((resp: any) => {
      if (resp.error) {
        return this.service.notificationService.open(resp.error);
      }
      this.handleFilterResponse(resp);
    })
  }

  fetchCompaniesIn(filter?, page?, isPageEvent?) {
    let extraFilters: any = {
      page: page ? page : this.currentPage
    }
    if (filter) {
      if (filter.searchTerm) {
        extraFilters.search_term = filter.searchTerm;
      }
      if (filter.page) {
        extraFilters.page = filter.page;
      }
      // type is the etf/stock type
      if (filter.type) {
        extraFilters.type = filter.type;
        delete filter.type;
      }
      if (filter.limit) {
        extraFilters.limit = filter.limit;
        delete filter.limit;
      }
    }
    this.service.fetchData(filter, extraFilters).subscribe((resp: any) => {
      if (resp.error) {
        return this.service.notificationService.open(resp.error);
      }
      this.handleFilterResponse(resp, isPageEvent);
    })
  }

  handleCompaniesResponse(resp, isPageEvent?) {
    if (resp.data) {
      if (isPageEvent) {
        let tempList = resp.data.map(r => {
          const company = new CompanyModel(r)
          company.selected = this.isCompanyInSelected(r) > -1
          return company;
        });
        this.list = this.list.concat(tempList);
      } else {
        this.list = resp.data.map(r => {
          const company = new CompanyModel(r)
          company.selected = this.isCompanyInSelected(r) > -1
          return company;
        });
      }
    }
    // If generated portfolio set every company as the selected list
    if (this.selectedPortfolioType == 2) {
      this.selected = this.list;
      this.sortSelectedList();
    }
    this.meta = new PageMeta(resp);
  }

  isCompanyInSelected(company) {
    //return this.selected.findIndex(el => el.security_id === company.security_id);
    return this.selected.findIndex(el => el.id === company.id);
  }

  onCompanySelect(selectInfo) {
    const selectedIndex = this.isCompanyInSelected(selectInfo.company);
    if (selectInfo.isSelected) {
      // selected, add to list
      if (selectedIndex > -1) {
        return this.service.notificationService.open('Company already selected with security id: ' + selectInfo.company.security_id);
      }
      if (this.selected.length < 100) {
        selectInfo.company.selected = true;
        if (selectInfo.company.isStock()) {
          // Add stock to start of array
          this.selected.unshift(selectInfo.company);
        } else {
          // Add !stock to end of array
          this.selected.push(selectInfo.company);
        }
      } else {
        return this.service.notificationService.open(`You can select only ${this.selectLimit} assets.`);
      }
    } else {
      // deselected
      if (selectedIndex > -1) {
        this.selected.splice(selectedIndex, 1);
        selectInfo.company.selected = false;
      }
    }

    this.checkETF();
    if ((this.portfolio.weighting_type === 'equal')) {
      this.setAllAssetEqual()
    } else {
      this.recalculateWeight()
    }
    this.updateSelectedCurrencyList();
    this.sortSelectedList();
  }

  sortSelectedList() {
    const sortingProps = ['-security_type_equity'];
    if (this.selectedSorting) {
      sortingProps.push(this.selectedSorting);
    }
    this.selected.sort(this.util.dynamicSortMultiple(sortingProps));
  }

  changeSelectedSorting(sortProperty) {
    this.selectedSorting = sortProperty;
    this.sortSelectedList();
  }

  onSelectedSortClick(type) {
    this.selectedSorting = this.service.checkSelectedSorting(this.selectedSorting, type);
    this.sortSelectedList();
  }

  updateSelectedCurrencyList() {
    this.selectedCurrencies = [];
    this.selected.map((company: CompanyModel) => {
      if (company.currency) {
        let i = this.selectedCurrencies.findIndex(x =>x.id == company.currency.id);
        if (i <= -1) {
          this.selectedCurrencies.push(company.currency);
        }
      }
      return company;
    });
  }

  recalculateWeight() {
    this.checkETF();
    if (this.portfolio.weighting_type === 'market_cap') { // market cap
      this.recalculateMarketCapWeight()
      return;
    }
    // recalculate equal weights
    let selectedStockLength = this.selected.length;
    let freeStockWeight = 100;

    let selectedETFLength = this.selected.filter(c => c.isETF()).length;
    let freeETFWeight = this.portfolio.etfPercent;

    if (selectedStockLength || selectedETFLength) {
      this.selected.map((company: CompanyModel) => {
        if (company.weightManuallyAdjusted) {
          if (company.isStock() || company.isFund() || company.isETF()) {
            selectedStockLength -= 1;
            freeStockWeight -= company.weight;
          } else {
            selectedETFLength -= 1;
            freeETFWeight -= company.weight;
          }
        }
      });

      const baseStockWeight = +(freeStockWeight / selectedStockLength).toFixed(2);
      const lastStockWeight = +(freeStockWeight - baseStockWeight * (selectedStockLength - 1)).toFixed(2);
      let stockIndex = 0;

      this.selected = this.selected.map((company: CompanyModel) => {
        if (!company.weightManuallyAdjusted) {
          if (company.isStock() || company.isFund() || company.isETF()) {
            stockIndex++;
            company.weight = stockIndex === selectedStockLength ? lastStockWeight : baseStockWeight;
          } else {
            company.weight = +(freeETFWeight / selectedETFLength).toFixed(2);
          }
        }
        return company;
      });
      this.weightError = freeStockWeight < 0 || freeETFWeight < 0;
      this.weightSumError = freeStockWeight > 0;
    }

  }

  onWeightChange(company) {
    this.portfolio.weighting_type = 'manual';
    company.weightManuallyAdjusted = company.weight;
  }

  recalculateMarketCapWeight() {
    let freeWeight = 100;

    // if (this.hasETF) {
    //   freeWeight = 100 - this.portfolio.etfPercent;
    //   const selectedETFLength = this.selected.filter(c => c.isETF()).length;
    //   this.selected = this.selected.map((company: CompanyModel) => {
    //     if (!company.isStock()) {
    //       company.weight = +(this.portfolio.etfPercent / selectedETFLength).toFixed(2);
    //     }
    //     return company;
    //   });
    // }
    let totalMarketCap = 0;
    this.selected.map((company: CompanyModel) => {
      if (company.isStock()) {
        totalMarketCap += +company.market_value_usd;
      }
      if (company.isFund()) {
        totalMarketCap += +company.fund_reference_table.AverageMarketCapital;
      }
      if(company.isETF())
        totalMarketCap += company.etf_reference_table.mcap;
    });
    this.selected = this.selected.map((company: CompanyModel) => {
      if (company.isStock()) {
        company.weight = +(+company.market_value_usd/totalMarketCap*freeWeight).toFixed(2);
      }
      if (company.isFund()) {
        company.weight = +(+company.fund_reference_table.AverageMarketCapital/totalMarketCap*freeWeight).toFixed(2);
      }
      if(company.isETF()){
        company.weight = +(company.etf_reference_table.mcap/totalMarketCap*freeWeight).toFixed(2);
      }
      return company;
    });
  }

  setAllAssetEqual() {
    const selectedStockLength = this.selected.filter(c => c.isStock()).length + this.selected.filter(c => c.isFund()).length;
    const selectedETFLength = this.selected.filter(c => c.isETF()).length;
    const totalLength = selectedStockLength + selectedETFLength;
    const freeWeight = 100;

    const baseWeight = +(freeWeight / totalLength).toFixed(2);
    const assignedTotal = +(baseWeight * (totalLength - 1)).toFixed(2);
    const lastWeight = +(freeWeight - assignedTotal).toFixed(2);

    this.selected = this.selected.map((company: CompanyModel, index: number) => {
      company.weight = index === totalLength - 1 ? lastWeight : baseWeight;
      return company;
    });
    this.portfolio.etfPercent = Math.round((selectedETFLength / totalLength) * 100);
  }

  onWeightTypeChange() {
    if (this.portfolio.weighting_type === 'equal') { // equal
      this.selected = this.selected.map((company: CompanyModel) => {
        company.weightManuallyAdjusted = false;
        return company;
      });
      this.setAllAssetEqual();
    } else if (this.portfolio.weighting_type === 'market_cap') { // market cap
      this.recalculateMarketCapWeight()
    }
  }

  onSelectAll(event) {
    // Add all company to the selected list
    if (event.selected === true) {
      this.list.map(c => {
        this.onCompanySelect({
          company: c,
          isSelected: true
        });
      });
    } else {
      // Remove all selecteds (by asset type)
      this.list = this.list.map(c => {
        c.selected = false;
        return c;
      });
      if (event.type === 'etf') {
        this.selected = this.selected.filter( (s: CompanyModel) => !s.isETF());
      } else if (event.type === 'fund') {
        this.selected = this.selected.filter( (s: CompanyModel) => !s.isFund());
      } else {
        this.selected = this.selected.filter( (s: CompanyModel) => !s.isStock());
      }
    }
    this.sortSelectedList();
  }

  onMaxStartDateChange(date) {
    if (date) {
      this.max_start_date = date;
      if (!this.portfolio.start_date_fixed) {
        this.portfolio.start_date = date;
      }
    }
  }

  onFileUploaded(list) {
    // Only add company to the selected list if not already there
    let maxDate = '1800-01-01';
    list.map((c: any) => {
      if (moment(c.p_first_date) > moment(maxDate)) {
        maxDate = c.p_first_date;
      }
      c.weightManuallyAdjusted = c.weight;
      const selectedIndex = this.isCompanyInSelected(c);
      if (selectedIndex == -1) {
        if (this.selected.length < 100) {
          c.selected = true;
          this.selected.push(c);
        } else {
          return this.service.notificationService.open(`You can select only ${this.selectLimit} assets.`);
        }
      }
    });
    this.portfolio.start_date = maxDate;
    this.portfolio.weighting_type = 'manual';
    this.updateSelectedCurrencyList();
    this.selectedPortfolioType = 1;
  }

  openSelectedType(typeNumber) {
    this.onSelectAll(false); //deselect all selected
    this.selectedPortfolioType = typeNumber;
    this.myStepper.next();

    if (this.selectedStep == 1) {
      if (this.selectedPortfolioType !== 1) {
        // generate portfolio
        // Collect available currencies for "generate" portfolio
        this.selected = this.list.slice(0, this.portfolio.limit);
        this.updateSelectedCurrencyList()
      }
    }
  }

  handleFilterResponse(resp, isPageEvent?) {
    // Update filter lists from response
    Object.entries(resp).forEach(([label, data]) => {
      if (label !== "list") {
        this.filterLists[label] = data;
      }
    });

    // Handle currencies
    this.filterLists.main_currencies = resp.currencies || this.filterLists.main_currencies;
    this.filterLists.currencies = (resp.currencies || resp.BaseCurrency || [])
      .map(c => ({ ...c, name: `${c.name}` }))
      .sort((a, b) => a.name.localeCompare(b.name));

    // Set static filter lists
    this.filterLists.size_classification = PortfolioCreateComponent.SIZE_CLASSIFICATIONS;
    this.filterLists.country_of_risk = PortfolioCreateComponent.COUNTRY_CODES;
    this.filterLists.flags = PortfolioCreateComponent.FLAGS;

    // Handle company list response
    if (resp.list) {
      this.handleCompaniesResponse(resp.list, isPageEvent);
    }

    // Set expected results count
    this.filterLists.expectedResults = resp.list?.meta?.total || 0;

    // update counts list
    this.updateCountsList();
  }

  updateCountsList() {
    this.filterLists.total_counts = {};
    Object.keys(this.filterLists).forEach(key => {
      if (Array.isArray(this.filterLists[key]) && this.filterLists[key].length > 0 && !!this.filterLists[key][0].count) {
        this.filterLists.total_counts[key] = 0;
        this.filterLists[key].forEach(item => {
          this.filterLists.total_counts[key] += item.count;
        });
      }
    });

    // need each asset class to have a count
    if (this.filterLists.asset_class) {
      this.filterLists.asset_class.forEach(item => {
        this.filterLists.total_counts[item.id] = item.count;
      });
    }
  }

  onPageEvent(data) {
    this.currentPage = data.page;
    this.fetchCompaniesIn(data.filters, null, data.isPageEvent);
  }

  stepChange(step) {
    this.selectedStep = step.selectedIndex;
  }

  openCartDialog() {
    const dialogRef = this.dialog.open(NewPortfolioSelectDialogComponent, {
      data: {
        list: this.selected,
        portfolio: this.portfolio
      },
      autoFocus: false,
      width: '100%'
    });

    dialogRef.afterClosed().subscribe( (resp: any) => {
      if (resp) {
        if (resp.list) {
          this.selected = [...resp.list];
          this.list = this.list.map(i => {
            i.selected = this.isCompanyInSelected(i) > -1;
            return i;
          })
          this.recalculateWeight();
        }
      }
    });
  }

  onPortfolioCartClick() {
    this.onStartDateSet(true)
  }

  convertSecurityIDsWithWeights() {
    let securityIDs:any = {}
    this.selected.map(s => {
      securityIDs[s.id] = {
        // set weight between 0-1
        weight: s.weight/100,
        type: s.security_type_equity
      }
    });
    return securityIDs;
  }

  getCurrencyIDByCode(code) {
    const currency = this.filterLists.currencies.filter(c => c.code === code)[0]
    return currency ? currency.id : 0;
  }

  extractCurrencyHedging() {
    this.selectedCurrencies = this.portfolio.currency_hedging.map((ch: any) => {
      return {
        id: this.getCurrencyIDByCode(ch.currency_code),
        code: ch.currency_code,
        hedging: ch.hedge_pct
      }
    })
  }

  getEndDate(){
     var t = moment();
     if(t.day() == 1)
      return moment(t.startOf("day")).set(
        "date",
        t.get("date") - 3
      );

     return moment(t.startOf("day")).set(
        "date",
        t.get("date") - 1
      );

   
  }

  onSavePortfolioClick(portfolio) {
    if (!portfolio.name || !portfolio.currency_id || !portfolio.start_date) {
      return this.service.notificationService.open("Please fill every mandatory field.")
    }
    if (!portfolio.benchmark) {
      return this.service.notificationService.open("Please select a benchmark.")
    }
    if (moment(portfolio.start_date).unix() < moment(this.max_start_date).unix()) {
      return this.service.notificationService.open("Start date can not be older than minimum asset start date: " + this.max_start_date)
    }

    if (!portfolio.visibility) {
      portfolio.visibility = VISIBILITY_PRIVATE;
    }
    portfolio.security_ids = this.convertSecurityIDsWithWeights();
    portfolio.end_date = this.getEndDate();

    if (this.selectedPortfolioType === 1) {
      // manual portfolio
      delete portfolio.country_ids;
      delete portfolio.industry_ids;
      delete portfolio.market_ids;
      delete portfolio.region_ids;
      delete portfolio.sector_ids;
    }

    // Convert hedging to portfolio property
    let currency_hedging = {};
    this.selectedCurrencies.map((c: any) => {
      if (c.id != portfolio.currency_id) {
        currency_hedging[c.code] = c.hedging;
      }
    })
    portfolio.currency_hedging = currency_hedging;

    this.service.saveItem(portfolio).subscribe((resp: any) => {
      if (resp.id) {
        this.service.notificationService.open("Portfolio saved");
        this.afterSavePortfolio(resp.id, portfolio.name);
      }
    })
  }

  onNextClick() {
    this.myStepper.next();
    if (this.selectedStep == 1) {
      if (this.selectedPortfolioType !== 1) {
        // generate portfolio
        // Collect available currencies for "generate" portfolio
        this.selected = this.list.slice(0, this.portfolio.limit);
        this.updateSelectedCurrencyList()
      }
    }
    this.recalculateWeight();
  }
  onBackClick() {
    this.myStepper.previous();
  }

  onCompanyInfoClick(company) {
    this.service.openCompanyInfoDialog(company.fs_ticker, company);
  }

  onUploadClick() {

    const dialogRef = this.dialog.open(UploadDialogComponent, {
      minWidth: '400px',
      maxWidth: '500px'
    });
    dialogRef.afterClosed().subscribe((resp: { companies: CompanyModel[], notFound: string[] }) => {
      if (resp && resp.companies && resp.companies.length) {
        this.service.uploadedNotFound = resp.notFound || [];
        this.onFileUploaded(resp.companies);
      }
    })
  }

  // Fetch market values at start date
  onStartDateSet(openCartAfterReceived = false) {
    const securities = this.selected.map(s => s.security_id);
    if (securities.length && this.portfolio.start_date) {
      this.service.getMarketValuesAtStart({
        date: this.portfolio.start_date,
        securities: securities
      }).subscribe((resp: any) => {
        if (resp && resp.success) {
          this.portfolio.start_date_fixed = true;
          const mcapList = resp.success;
          this.selected = this.selected.map((company: CompanyModel) => {
            if (mcapList[company.security_id]) {
              company.market_value_start = `${mcapList[company.security_id].mcap/1000}`; // Fix mcp value
            }
            return company
          });
          // Recalculate weight if weigting type market_cap
          if (this.portfolio.weighting_type == 'market_cap') {
            this.recalculateMarketCapWeight();
          }

          if (openCartAfterReceived) {
            this.openCartDialog()
          }
        }
      })
    }
  }

  checkETF() {
    this.hasETF = false; //this.service.hasETF(this.selected);
    if (!this.hasETF) {
      this.portfolio.etfPercent = 0;
    }
  }

  onHistoryBackClick() {
    this.location.back();
  }

  protected afterSavePortfolio(portfolioId: number, portfolioName: string) {
    this.startPortfolioPolling(portfolioId, portfolioName);
    this.router.navigate(['/app']);
  }

  protected startPortfolioPolling(portfolioID: number, portfolioName: string = '', initialDelay = 10000) {
    this.portfolioPollingService.watchPortfolio(portfolioID, {
      onStatusComplete: () => {
        this.service.notificationService.openWithAction("Portfolio " + portfolioName + " computation finished", "Open", '/app/portfolio-view/' + portfolioID + '/overview');
        this.service.portfolioFinished.next({id: portfolioID});
      },
      pollingInterval: 6000,
      initialDelay,
      listenerKey: `portfolio-${portfolioID}`,
      context: this
    });
  }
}
